export default __webpack_public_path__ + "static/click-468671cf259ed136d5cf8a25e612a97f.mp3";